import {
  isBigResultsPitchCarouselVariant,
  isBigResultsPitchMockupVariant,
  isGoalPitchMockupVariant,
  isSocialProofMillionsVariant,
} from 'data/images/utils'
import type { ImagesDefinition } from 'types/images'

export const GYMF01_IMAGES = {
  experience: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/gymf01/realistic/experience.webp',
        '/images/gymf01/realistic/experience@2x.webp',
      ],
    },
  },
  experiencePitch: {
    pitch: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/gymf01/realistic/experience_pitch.webp',
        '/images/gymf01/realistic/experience_pitch@2x.webp',
      ],
    },
  },
  flexible: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/gymf01/realistic/flexible.webp',
        '/images/gymf01/realistic/flexible@2x.webp',
      ],
    },
  },
  stairsCardio: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/gymf01/realistic/stairs_cardio.webp',
        '/images/gymf01/realistic/stairs_cardio@2x.webp',
      ],
    },
  },
  howOftenExercise: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/gymf01/realistic/how_often_exercise.webp',
        '/images/gymf01/realistic/how_often_exercise@2x.webp',
      ],
    },
  },
  workoutLocation: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/gymf01/realistic/workout_location.webp',
        '/images/gymf01/realistic/workout_location@2x.webp',
      ],
    },
  },
  gymConfidencePitch: {
    mockup: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/gymf01/realistic/gym-confidence-pitch/gym_confidence_pitch_{{locale}}.webp',
        '/images/gymf01/realistic/gym-confidence-pitch/gym_confidence_pitch_{{locale}}@2x.webp',
      ],
    },
  },
  locationCombinationPitch: {
    mockup: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/gymf01/realistic/location-combination-pitch/location_combination_pitch_{{locale}}.webp',
        '/images/gymf01/realistic/location-combination-pitch/location_combination_pitch_{{locale}}@2x.webp',
      ],
    },
  },
  difficultyPitch: {
    mockup: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/gymf01/realistic/difficulty-pitch/difficulty_pitch_{{locale}}.webp',
        '/images/gymf01/realistic/difficulty-pitch/difficulty_pitch_{{locale}}@2x.webp',
      ],
    },
  },
  howOftenWalks: {
    background: {
      width: 402,
      height: 540,
      srcSet: [
        '/images/gymf01/realistic/how_often_walks.webp',
        '/images/gymf01/realistic/how_often_walks@2x.webp',
      ],
    },
  },
  mainGoal: {
    gainMuscle: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/gymf01/realistic/goal/main_goal_option_gain_muscle.webp',
        '/images/gymf01/realistic/goal/main_goal_option_gain_muscle@2x.webp',
      ],
    },
    improveFitness: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/gymf01/realistic/goal/main_goal_option_improve_fitness.webp',
        '/images/gymf01/realistic/goal/main_goal_option_improve_fitness@2x.webp',
      ],
    },
    loseFatGainMuscle: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/gymf01/realistic/goal/main_goal_option_lose_fat_gain_muscle.webp',
        '/images/gymf01/realistic/goal/main_goal_option_lose_fat_gain_muscle@2x.webp',
      ],
    },
    loseWeight: {
      width: 186,
      height: 140,
      srcSet: [
        '/images/gymf01/realistic/goal/main_goal_option_lose_weight.webp',
        '/images/gymf01/realistic/goal/main_goal_option_lose_weight@2x.webp',
      ],
    },
  },
  bodyTypePitch: {
    endomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/gymf01/realistic/body-type-pitch/body_type_pitch_endomorph.webp',
        '/images/gymf01/realistic/body-type-pitch/body_type_pitch_endomorph@2x.webp',
      ],
    },
    mesomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/gymf01/realistic/body-type-pitch/body_type_pitch_mesomorph.webp',
        '/images/gymf01/realistic/body-type-pitch/body_type_pitch_mesomorph@2x.webp',
      ],
    },
    ectomorph: {
      width: 120,
      height: 256,
      srcSet: [
        '/images/gymf01/realistic/body-type-pitch/body_type_pitch_ectomorph.webp',
        '/images/gymf01/realistic/body-type-pitch/body_type_pitch_ectomorph@2x.webp',
      ],
    },
  },
  physicalBuild: {
    extended: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/gymf01/realistic/physical-build/physical_build_option_extended.webp',
        '/images/gymf01/realistic/physical-build/physical_build_option_extended@2x.webp',
      ],
    },
    fullfigured: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/gymf01/realistic/physical-build/physical_build_option_fullfigured.webp',
        '/images/gymf01/realistic/physical-build/physical_build_option_fullfigured@2x.webp',
      ],
    },
    midsized: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/gymf01/realistic/physical-build/physical_build_option_midsized.webp',
        '/images/gymf01/realistic/physical-build/physical_build_option_midsized@2x.webp',
      ],
    },
    slim: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/gymf01/realistic/physical-build/physical_build_option_slim.webp',
        '/images/gymf01/realistic/physical-build/physical_build_option_slim@2x.webp',
      ],
    },
  },
  bigResultsPitch: {
    first: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/gymf01/realistic/big-results-pitch/big_results_pitch_01.webp',
        '/images/gymf01/realistic/big-results-pitch/big_results_pitch_01@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchCarouselVariant,
    },
    second: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/gymf01/realistic/big-results-pitch/big_results_pitch_02.webp',
        '/images/gymf01/realistic/big-results-pitch/big_results_pitch_02@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchCarouselVariant,
    },
    third: {
      width: 272,
      height: 320,
      srcSet: [
        '/images/gymf01/realistic/big-results-pitch/big_results_pitch_03.webp',
        '/images/gymf01/realistic/big-results-pitch/big_results_pitch_03@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchCarouselVariant,
    },
    mockup: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/gymf01/realistic/big-results-pitch/big_results_pitch_mockup_{{locale}}.webp',
        '/images/gymf01/realistic/big-results-pitch/big_results_pitch_mockup_{{locale}}@2x.webp',
      ],
      prefetchCondition: isBigResultsPitchMockupVariant,
    },
  },
  goalPitch: {
    mockup: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/gymf01/realistic/goal-pitch/goal_pitch_mockup_{{locale}}.webp',
        '/images/gymf01/realistic/goal-pitch/goal_pitch_mockup_{{locale}}@2x.webp',
      ],
      prefetchCondition: isGoalPitchMockupVariant,
    },
  },
  socialProofMillions: {
    pitch: {
      width: 370,
      height: 364,
      srcSet: [
        '/images/gymf01/realistic/social_proof_millions.webp',
        '/images/gymf01/realistic/social_proof_millions@2x.webp',
      ],
      prefetchCondition: isSocialProofMillionsVariant('default'),
    },
    group: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/gymf01/realistic/social-proof-millions/group.webp',
        '/images/gymf01/realistic/social-proof-millions/group@2x.webp',
      ],
      prefetchCondition: isSocialProofMillionsVariant('group'),
    },
  },
  struggle: {
    back: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/gymf01/realistic/struggle/struggle_option_back.webp',
        '/images/gymf01/realistic/struggle/struggle_option_back@2x.webp',
      ],
    },
    knees: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/gymf01/realistic/struggle/struggle_option_knees.webp',
        '/images/gymf01/realistic/struggle/struggle_option_knees@2x.webp',
      ],
    },
    none: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/gymf01/realistic/struggle/struggle_option_none.webp',
        '/images/gymf01/realistic/struggle/struggle_option_none@2x.webp',
      ],
    },
  },
  strugglePitch: {
    knees: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/gymf01/realistic/struggle-pitch/struggle_pitch_knees.webp',
        '/images/gymf01/realistic/struggle-pitch/struggle_pitch_knees@2x.webp',
      ],
    },
    back: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/gymf01/realistic/struggle-pitch/struggle_pitch_back.webp',
        '/images/gymf01/realistic/struggle-pitch/struggle_pitch_back@2x.webp',
      ],
    },
    both: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/gymf01/realistic/struggle-pitch/struggle_pitch_both.webp',
        '/images/gymf01/realistic/struggle-pitch/struggle_pitch_both@2x.webp',
      ],
    },
  },
  problemAreas: {
    belly: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/gymf01/realistic/problem-areas/problem_areas_option_belly.webp',
        '/images/gymf01/realistic/problem-areas/problem_areas_option_belly@2x.webp',
      ],
    },
    butt: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/gymf01/realistic/problem-areas/problem_areas_option_butt.webp',
        '/images/gymf01/realistic/problem-areas/problem_areas_option_butt@2x.webp',
      ],
    },
    chest: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/gymf01/realistic/problem-areas/problem_areas_option_chest.webp',
        '/images/gymf01/realistic/problem-areas/problem_areas_option_chest@2x.webp',
      ],
    },
    legs: {
      width: 186,
      height: 86,
      srcSet: [
        '/images/gymf01/realistic/problem-areas/problem_areas_option_legs.webp',
        '/images/gymf01/realistic/problem-areas/problem_areas_option_legs@2x.webp',
      ],
    },
  },
  problemAreasPitch: {
    mockup: {
      width: 370,
      height: 300,
      srcSet: [
        '/images/gymf01/realistic/problem-areas-pitch/problem_areas_pitch_mockup_{{locale}}.webp',
        '/images/gymf01/realistic/problem-areas-pitch/problem_areas_pitch_mockup_{{locale}}@2x.webp',
      ],
    },
  },
  waterIntake: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/gymf01/realistic/water_intake.webp',
        '/images/gymf01/realistic/water_intake@2x.webp',
      ],
    },
  },
  sleepDuration: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/gymf01/realistic/sleep_duration.webp',
        '/images/gymf01/realistic/sleep_duration@2x.webp',
      ],
    },
  },
  bodyGoal: {
    thin: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/gymf01/realistic/body-goal/body_goal_option_thin.webp',
        '/images/gymf01/realistic/body-goal/body_goal_option_thin@2x.webp',
      ],
    },
    toned: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/gymf01/realistic/body-goal/body_goal_option_toned.webp',
        '/images/gymf01/realistic/body-goal/body_goal_option_toned@2x.webp',
      ],
    },
    curvy: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/gymf01/realistic/body-goal/body_goal_option_curvy.webp',
        '/images/gymf01/realistic/body-goal/body_goal_option_curvy@2x.webp',
      ],
    },
    average: {
      width: 181,
      height: 149,
      srcSet: [
        '/images/gymf01/realistic/body-goal/body_goal_option_average.webp',
        '/images/gymf01/realistic/body-goal/body_goal_option_average@2x.webp',
      ],
    },
  },
  welcomeAgeBuckets: {
    heroBackground: {
      width: 651,
      height: 651,
      srcSet: [
        '/images/gymf01/realistic/welcome-age-buckets/hero_background.webp',
        '/images/gymf01/realistic/welcome-age-buckets/hero_background@2x.webp',
      ],
    },
    heroBackgroundDesktop: {
      width: 1436,
      height: 651,
      srcSet: [
        '/images/gymf01/realistic/welcome-age-buckets/hero_background_desktop.webp',
        '/images/gymf01/realistic/welcome-age-buckets/hero_background_desktop@2x.webp',
      ],
    },
  },
  timeBreakfast: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/gymf01/realistic/time_breakfast.webp',
        '/images/gymf01/realistic/time_breakfast@2x.webp',
      ],
    },
  },
  timeLunch: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/gymf01/realistic/time_lunch.webp',
        '/images/gymf01/realistic/time_lunch@2x.webp',
      ],
    },
  },
  timeDinner: {
    header: {
      width: 370,
      height: 233,
      srcSet: [
        '/images/gymf01/realistic/time_dinner.webp',
        '/images/gymf01/realistic/time_dinner@2x.webp',
      ],
    },
  },
  wellnessProfile: {
    extended: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/gymf01/realistic/wellness-profile/wellness_profile_extended.webp',
        '/images/gymf01/realistic/wellness-profile/wellness_profile_extended@2x.webp',
      ],
    },
    fullFigured: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/gymf01/realistic/wellness-profile/wellness_profile_fullfigured.webp',
        '/images/gymf01/realistic/wellness-profile/wellness_profile_fullfigured@2x.webp',
      ],
    },
    midSized: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/gymf01/realistic/wellness-profile/wellness_profile_midsized.webp',
        '/images/gymf01/realistic/wellness-profile/wellness_profile_midsized@2x.webp',
      ],
    },
    slim: {
      width: 148,
      height: 273,
      srcSet: [
        '/images/gymf01/realistic/wellness-profile/wellness_profile_slim.webp',
        '/images/gymf01/realistic/wellness-profile/wellness_profile_slim@2x.webp',
      ],
    },
  },
  subscription: {
    beforeExtended: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_before_extended.webp',
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_before_extended@2x.webp',
      ],
    },
    beforeFullfigured: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_before_fullfigured.webp',
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_before_fullfigured@2x.webp',
      ],
    },
    beforeMidsized: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_before_midsized.webp',
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_before_midsized@2x.webp',
      ],
    },
    beforeSlim: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_before_slim.webp',
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_before_slim@2x.webp',
      ],
    },
    afterThin: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_after_thin.webp',
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_after_thin@2x.webp',
      ],
    },
    afterToned: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_after_toned.webp',
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_after_toned@2x.webp',
      ],
    },
    afterCurvy: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_after_curvy.webp',
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_after_curvy@2x.webp',
      ],
    },
    afterAverage: {
      width: 186,
      height: 263,
      srcSet: [
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_after_average.webp',
        '/images/gymf01/realistic/subscription/goal-body/paywall_comparison_after_average@2x.webp',
      ],
    },
  },
} satisfies ImagesDefinition
